export const verificationStatusOptions = [
  { label: 'Chờ phát hành', value: 0 },
  { label: 'Chờ ký', value: 1 },
  { label: 'Xác thực', value: 2 },
  { label: 'Điều chỉnh', value: 3 },
  { label: 'Thay thế', value: 4 },
  { label: 'Thuế từ chối', value: 5 },
  { label: 'Chờ hủy', value: 6 },
  { label: 'Hủy', value: 7 },
  { label: 'Thuế không đồng ý', value: 8 }
];
